<div class="page__content">
    <div class="content__inner">
        <div class="content__login">
            <div class="card__login">
                <form *ngIf="!isSuccessful" name="form" (ngSubmit)="preSubmit() && form.valid && onSubmit()" [formGroup]="form">
                    <h1>{{ 'RESET_PASSWORD.SUBMIT' | translate }}</h1>
                    <div class="form-group">
                        <input type="email" class="form-control" name="email" formControlName="email"
                            [placeholder]="'PLACEHOLDER.EMAIL' | translate" />
                        <div class="alert-danger" *ngIf="form.controls['email']?.errors && form.controls['newPassword']?.touched">
                            <div *ngIf="form.controls['email']?.errors['required']">{{ 'RESET_PASSWORD.ERROR.EMAIL_REQUIRED' | translate }}</div>
                            <div *ngIf="form.controls['email']?.errors['email']">{{ 'RESET_PASSWORD.ERROR.EMAIL_INVALID' | translate }}</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <input type="password" class="form-control" name="newPassword" formControlName="newPassword"
                             minlength="6"
                             [placeholder]="'PLACEHOLDER.CONTRASENA' | translate" autocomplete="new-password"
                             [ngClass]="{'is-invalid': form?.controls && form.controls['newPassword']?.invalid && form.controls['newPassword']?.touched}"
                             />
                        <div class="alert-danger" role="alert" *ngIf="form.controls['newPassword'].errors && form.controls['newPassword']?.touched">
                            <div *ngIf="form.controls['newPassword']?.errors['required']">
                                {{ 'RESET_PASSWORD.ERROR.PASSWORD_REQUIRED' | translate }}
                            </div>
                            <div *ngIf="form.controls['newPassword']?.errors['minlength']">
                                {{ 'RESET_PASSWORD.ERROR.PASSWORD_MIN_LENGTH' | translate }}
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <input type="password" class="form-control" name="newPasswordConfirm" formControlName="newPasswordConfirmar"
                             [placeholder]="'RESET_PASSWORD.CONFIRM_PASSWORD' | translate" autocomplete="new-password"
                             [ngClass]="{'is-invalid':form.controls['newPasswordConfirmar']?.invalid && form.controls['newPasswordConfirmar']?.touched}" />
                        <div class="alert-danger" role="alert" *ngIf="form.controls['newPasswordConfirmar']?.errors && form.controls['newPasswordConfirmar']?.touched">
                            <div *ngIf="form.controls['newPasswordConfirmar']?.errors['required']">
                                {{ 'RESET_PASSWORD.ERROR.PASSWORD_REQUIRED' | translate }}
                            </div>
                            <div *ngIf="form.controls['newPasswordConfirmar']?.errors['passwordMatchValidator']">
                                {{ 'RESET_PASSWORD.ERROR.PASSWORD_MISMATCH' | translate }}
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="form-group">
                            <button class="btn btn-primary btn-block" [disabled]="loading">
                                {{ 'RESET_PASSWORD.SUBMIT' | translate }}
                            </button>
                        </div>
                    </div>
                    <div class="form-group">
                        <a routerLink="/login" class="forgot-password">{{ 'NOTIFICATION.BUTTON.CANCEL' | translate }}</a>
                    </div>
                </form>
                <div class="alert alert-success" *ngIf="isSuccessful">
                    {{ 'RESET_PASSWORD.SUCCESS' | translate }}
                </div>
            </div>
        </div>
    </div>
</div>
